import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { QuickBooksObjectDataset } from 'app/model/dataset/quick-books.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(QuickBooksObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class QuickBooksObjectDatasetAdapter extends TabularTypeDatasetAdapter<QuickBooksObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: QuickBooksObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(QuickBooksObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: QuickBooksObjectDataset): Promise<QuickBooksObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, QuickBooksObjectDataset.MODEL);
    }
}
